
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './holidays.json';

const Holidays = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Holiday traditions, celebrations, and cultural vocabulary. B2 level grammar, vocabulary, and speaking exercises."
            level="B2"
            title="Holidays"
            image="/Images/OutofOffice.webp"
            seoTitle="Free English Lesson Plans: Holidays"
            seoDescription="Holiday traditions, celebrations, and cultural vocabulary. B2 level grammar, vocabulary, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Holidays;


